export default "__VITE_ASSET__695aeb89__"